import script from "./MaterialComponentTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialComponentTable.vue?vue&type=script&setup=true&lang=js"

import "./MaterialComponentTable.vue?vue&type=style&index=0&id=96d18f5a&lang=css"

const __exports__ = script;

export default __exports__